import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useHistory } from "react-router-dom";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import Cookies from "js-cookie"

export default function  Authentification (props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const [token, setToken]  = useState(new URLSearchParams(useLocation().search).get("c_token"));
  const getLogIcon = useLogIcon();
  const isInputValid = useValidationInput();
  const axiosOperation = useAxiosOperation();
  const history = useHistory();
  const  [user, setUser] = useState({ 
    id: 1,
    email : "",
    password : "",
    errors:[],
    company: {siteName:new URLSearchParams(useLocation().search).get("siteName")}
  })
  
    const getError = (id) => {
    const error =  user.errors.filter(item => item.id == id)[0]
    return <div style={{border:"none", backgroundColor:"transparent", userSelect:"none",
      paddingTop:"0px", marginTop:"0px", height:"15px",  color: "rgb(206, 17, 38)", fontSize: 10}} 
      >{error ? error.text: ""}</div>
  
  };

  
  useEffect(() => {
    var userData = JSON.parse(JSON.stringify(user));
        
    if (token != null) {
      
      setUser({...userData, loading:true })
      axiosOperation({method:"PATCH"
        , url: "https://flex-services.onrender.com/user/"+ token + "/"
        , body: {confirmed:true, nTry:0}
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              var log = {type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}
              if (user.company.siteName == null)
                setUser({...userData, log:log})
              else {
                axiosOperation({method:"GET"
                , url: "https://flex-services.onrender.com/login/"+ user.company.siteName + "/"
                , body: {confirmed:true, nTry:0}
                }).then(response => 
                  { 
                    var company = JSON.parse(JSON.stringify(user.company))
                    if(response.managedError) {
                      const result = response.result.data[0]
                     
                      if (result)
                        company = {...user.company, ...result}
                    }
                    
                    setUser({...userData, log:log, company:company})
                  })

              }
            }
            else {
              log = {text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })

    } else if (user.company.siteName != null) {  
      setUser({...userData, loading:true })
      axiosOperation({method:"GET"
        , url: "https://flex-services.onrender.com/login/"+ user.company.siteName + "/"
        , body: {confirmed:true, nTry:0}
        }).then(response => 
          { 
            var company = {}
            if(response.managedError) {
              const result = response.result.data[0]
             
              if (result)
                company = {...user.company, ...result}
            }
         
            setUser({...userData, company:company})
          })
    } 

    
  }, []); //onLoad

  const fireOtherEvent = (e, detail, typeValidation) => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(e.target.value, detail, typeValidation, userData) 
    setUser(userData);
  }

  const fireEventKeyPress = (e, detail, typeValidations) => {
     
    var userData = JSON.parse(JSON.stringify(user));
    userData.errors = userData.errors.filter(error => error.id != detail.id )

    if(typeValidations,  !isInputValid({value: e.key}, typeValidations).isValid) {
      e.preventDefault()
    }
    setUser(userData);
  }

  const validInput = (value, detail, typeValidation, userData) => {
    const eventResponse = isInputValid({value: value}, typeValidation);
    if(eventResponse.isValid) {
      userData.errors = userData.errors.filter(error => error.id != detail.id )
    }
    else {
      userData.errors.push({id:detail.id
        , text: eventResponse.type == "EMAIL" ? "The email is invalid" : "The field is required".replace("field", detail.name)})
    }
  }

  const onClick = () => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(user.email, {id:"Email", name:"Email" }, [{type :"REQUIRE"}], userData) 
    validInput(user.password, {id:"Password", name:"Password" }, [{type :"REQUIRE"}], userData)
    if (userData.errors.length == 0) {
      var userData = JSON.parse(JSON.stringify(user));
      
      setUser({...userData, loading:true })
      
      if (user.log && user.log.activeResendEmail)
        axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/user/"
        , body:userData
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
      else
        axiosOperation({method:"POST"
          , url: "https://flex-services.onrender.com/login/"
          , body: userData
          , headers: {xsrfHeaderName:'X-CSRFToken'}
          }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data 
              
              if (result.log.type == "INFO") {
                                
                dispatch({
                  type: "SET_ACCESS_TOKEN",
                  payload: user.company.siteName == null ? {company:result["user"], accessToken: result["access_token"] } : {user:result["user"], accessToken: result["access_token"] }
                });
               
                if (user.company.siteName == null)
              
                  history.push('/information')
                else {
                  
                  if (result.resetPassword)
                    history.push({pathname: '/changePassword', search: `?c_token=${result.token}&id=${user.company.id}&siteName=${user.company.siteName}`})
                  else {
                    
                    dispatch({
                      type: result.home != null ? "INITIALIZE_FORM" : "REFRESH_FORM",
                      payload: {formData: JSON.parse(result.home), isCustomHome:true},
                    });
                    history.push('/customHome')

                  }
                }
              } 
              else
                setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
              
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
            })
      
    }
    else
      setUser(userData);
  }

  const refreshForm = () => {
  
    const userData = { 
      id: 1,
      email : "",
      password : "",
      errors:[],
      loading:false
    }
   
    setUser(userData);
  }

  const canClick = user.errors.length == 0 && !user.loading

  return (
  <React.Fragment>
    {user.company && user.company.fullName && 
      <div style = {{ marginLeft:"auto", marginRight:"auto",  marginTop:"30px", minWidth:"250px", textAlign:"center" }} >
        <span style = {{ fontFamily:"sans-serif",fontSize:"18px", color:"gray" }} >{`WelCome to ${user.company.fullName}`}</span>
      </div>
    }
    <div style = {{ marginLeft:"auto", marginRight:"auto",  width:"250px"
    , padding: "20px", borderRadius: "4px"
    , marginTop:"30px", backgroundColor: "white" }}>
      <div style = {{ display:"flex"  }}>
        <span style = {{ fontFamily:"Verdana",fontSize:"16px"  }} >Sign in</span>
        <div style = {{ marginLeft:"10px"  }}>
        { user.loading ? <SpinnerIcon /> : (user.log ? getLogIcon(user.log.type) : null)}
        </div>
      </div>
      <div style = {{ marginBottom:"5px"  }}>
        { user.log && <span style = {user.log.style} >{user.log.text}</span>}
      </div>
      <input id="Email" type="textBox" placeholder="Email" value={user.email} 
        readOnly={user.log && user.log.activeResendEmail} 
        onChange={(e)=> setUser({...user, email:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
        style = {{marginTop:"10px"  }}
        className="input connexionInput" />
      {getError("Email")}
      <input id="Password" type="password"  placeholder="Password" value={user.password} 
          autoComplete="off"
          onChange={(e)=> setUser({...user, password:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"Password", name:"Password" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"Password" })}
          className="input connexionInput" />  
        {getError("Password")}
        <div style = {{ textAlign:"center", display:"flex" , marginBottom:"5px" }}>
          <input disabled={!canClick} type="button" className="button" 
            style = {{ height:"30px", width: user.log && user.log.activeResendEmail ? "120px" : "250px"
            , marginTop:"5px", backgroundColor:canClick ? "#008dff" : "lightGray" }} 
            onClick = {(e) => onClick(e)}
            value=  {user.log && user.log.activeResendEmail ? "Resend Email" : "Sign In"} />
          {user.log && user.log.activeResendEmail && <input disabled={!canClick} 
            type="button" className="button" 
            style = {{ height:"30px", width:"120px", marginTop:"5px"
            , marginLeft:"10px"
            , backgroundColor:canClick ? "#008dff" : "lightGray" }} 
            value= "Another user" 
            onClick = {(e) => refreshForm()} 
          />}
        </div>
        <div style = {{  display:"flex" }}>
          {user.company.siteName == null ? 
            <Link  style = {{ fontFamily:"Verdana", marginRight:"auto", textDecoration: "none"  }}to="/forgetPassword">
              <span style = {{ fontSize:"12px", color:"#008dff"}} >Forgot password?</span>
            </Link>
          :
            <div className = "link" onClick = {() => history.push({pathname: '/forgetPassword', search: `?id=${user.company.id}&siteName=${user.company.siteName}`})}>
              <span>Forgot password?</span>
            </div>
          }
      </div>
    </div>
  </React.Fragment>
  );
};

/*
<span style = {{ fontSize:"14px", width:"250px", color:"#212121" }} >Register</span>*/